import { render, staticRenderFns } from "./ObjectsUpdateAcl.vue?vue&type=template&id=77735d50&"
import script from "./ObjectsUpdateAcl.vue?vue&type=script&lang=js&"
export * from "./ObjectsUpdateAcl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports